$(function () {
    const CART_STORAGE_KEY = 'cartAvailability_' + window.location.hostname;

    /*
        Zapnutí / vypnutí diagnostiky.
        true  = loguje do konzole
        false = ticho
    */
    const DEBUG_CART_AVAILABILITY = true;

    /*
        Kódy položek, které se nemají vůbec počítat do logiky dopravy.
        Typicky dýško, služby, doplňky apod.

        Důležité:
        Pokud je v košíku dýško + předobjednávka,
        nesmí se dýško počítat jako klasické zboží.
    */
    const IGNORE_AVAILABILITY_CODES = [
        '134619',
        '9999787',
        '9999788',
        '134613',
        '134616'
    ];

    function debugCartAvailability(label, data) {
        if (!DEBUG_CART_AVAILABILITY) return;

        if (typeof console.groupCollapsed === 'function') {
            console.groupCollapsed('[Cart availability debug] ' + label);
            console.log(data);
            console.groupEnd();
        } else {
            console.log('[Cart availability debug] ' + label, data);
        }
    }

    function normalizeText(value) {
        return String(value || '')
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
    }

    function isIgnoredAvailabilityCode(code) {
        const normalizedCode = String(code || '').trim();

        return IGNORE_AVAILABILITY_CODES.includes(normalizedCode);
    }

    function collectCartAvailability() {
        const items = [];

        $('.cart-table tbody tr.removeable').each(function (index) {
            const $row = $(this);

            const code = $row.attr('data-micro-sku') || '';
            const name = $row.find('.p-name .main-link').text().trim();

            const availabilityText = $row
                .find('.availability-label')
                .first()
                .text()
                .trim();

            const item = {
                index: index,
                code: code,
                name: name,
                availability: availabilityText
            };

            items.push(item);
        });

        debugCartAvailability('collectCartAvailability() - položky z košíku', {
            count: items.length,
            items: items
        });

        return items;
    }

    function saveCartAvailabilityToStorage() {
        const data = {
            items: collectCartAvailability(),
            savedAt: Date.now(),
            savedAtReadable: new Date().toLocaleString()
        };

        sessionStorage.setItem(CART_STORAGE_KEY, JSON.stringify(data));

        debugCartAvailability('saveCartAvailabilityToStorage() - uloženo do sessionStorage', {
            key: CART_STORAGE_KEY,
            data: data
        });
    }

    function getCartAvailabilityFromStorage() {
        const raw = sessionStorage.getItem(CART_STORAGE_KEY);

        debugCartAvailability('getCartAvailabilityFromStorage() - raw hodnota', {
            key: CART_STORAGE_KEY,
            raw: raw
        });

        if (!raw) return null;

        try {
            const data = JSON.parse(raw);

            if (!data || !Array.isArray(data.items)) {
                debugCartAvailability('getCartAvailabilityFromStorage() - špatný formát dat', {
                    data: data
                });

                return null;
            }

            debugCartAvailability('getCartAvailabilityFromStorage() - načtené položky', {
                savedAt: data.savedAt,
                savedAtReadable: data.savedAtReadable,
                items: data.items
            });

            return data.items;
        } catch (e) {
            debugCartAvailability('getCartAvailabilityFromStorage() - chyba JSON.parse', {
                error: e,
                raw: raw
            });

            return null;
        }
    }

    function isPreorderAvailability(availability) {
        return normalizeText(availability).includes(
            normalizeText(predobjednavkaLabel)
        );
    }

    function isOwnDeliveryAvailability(availability) {
        return normalizeText(availability).includes(
            normalizeText(vlastniDopravaLabel)
        );
    }

    function getCartAvailabilityState(items) {
        let hasPreorder = false;
        let hasOwnDelivery = false;
        let hasClassic = false;

        const diagnostics = [];

        items.forEach(function (item, index) {
            const availability = item.availability || '';
            const code = item.code || '';
            const name = item.name || '';

            const ignored = isIgnoredAvailabilityCode(code);
            const preorder = isPreorderAvailability(availability);
            const ownDelivery = isOwnDeliveryAvailability(availability);

            const diagnosticItem = {
                index: index,
                code: code,
                name: name,
                availability: availability,
                normalizedAvailability: normalizeText(availability),
                ignoredByCode: ignored,
                isPreorderAvailability: preorder,
                isOwnDeliveryAvailability: ownDelivery,
                result: null
            };

            /*
                Ignore kódy:
                Tyto položky se vůbec nepočítají do logiky dopravy.
                Neudělají hasClassic, hasPreorder ani hasOwnDelivery.
            */
            if (ignored) {
                diagnosticItem.result = 'IGNORED';
                diagnostics.push(diagnosticItem);
                return;
            }

            if (preorder) {
                hasPreorder = true;
                diagnosticItem.result = 'PREORDER';
                diagnostics.push(diagnosticItem);
                return;
            }

            if (ownDelivery) {
                hasOwnDelivery = true;
                diagnosticItem.result = 'OWN_DELIVERY';
                diagnostics.push(diagnosticItem);
                return;
            }

            hasClassic = true;
            diagnosticItem.result = 'CLASSIC';
            diagnostics.push(diagnosticItem);
        });

        const state = {
            hasPreorder: hasPreorder,
            hasOwnDelivery: hasOwnDelivery,
            hasClassic: hasClassic,

            onlyPreorder: hasPreorder && !hasClassic && !hasOwnDelivery,
            onlyClassic: hasClassic && !hasPreorder && !hasOwnDelivery,
            onlyOwnDelivery: hasOwnDelivery && !hasPreorder && !hasClassic,

            preorderAndClassic: hasPreorder && hasClassic && !hasOwnDelivery,
            preorderAndOwnDelivery: hasPreorder && hasOwnDelivery,
            classicAndOwnDelivery: hasClassic && hasOwnDelivery && !hasPreorder
        };

        debugCartAvailability('getCartAvailabilityState() - vyhodnocení položek', {
            diagnostics: diagnostics,
            state: state
        });

        return state;
    }

    function getSplitShippingWrapper() {
        const $split = $(idPredobjednavka);

        debugCartAvailability('getSplitShippingWrapper() - hledám split dopravu', {
            selector: idPredobjednavka,
            found: $split.length
        });

        if (!$split.length) {
            return $();
        }

        if ($split.hasClass('radio-wrapper')) {
            return $split;
        }

        return $split.closest('.radio-wrapper');
    }

    function selectSplitShipping() {
        const $splitWrapper = getSplitShippingWrapper();

        debugCartAvailability('selectSplitShipping() - start', {
            splitWrapperFound: $splitWrapper.length
        });

        if (!$splitWrapper.length) return;

        const $input = $splitWrapper.find('input[type="radio"]').first();

        debugCartAvailability('selectSplitShipping() - input', {
            inputFound: $input.length,
            inputValue: $input.val()
        });

        if (!$input.length) return;

        $('#order-shipping-methods > div.active').removeClass('active');

        $splitWrapper
            .addClass('active')
            .show();

        $input
            .prop('disabled', false)
            .prop('checked', true)
            .trigger('click')
            .trigger('change');

        if (
            window.shoptet &&
            shoptet.checkoutShared
        ) {
            if (typeof shoptet.checkoutShared.callShippingBillingRelations === 'function') {
                shoptet.checkoutShared.callShippingBillingRelations();

                debugCartAvailability('selectSplitShipping() - callShippingBillingRelations spuštěno', {});
            }

            if (typeof shoptet.checkoutShared.replacingChosenShippingAndBilling === 'function') {
                shoptet.checkoutShared.replacingChosenShippingAndBilling();

                debugCartAvailability('selectSplitShipping() - replacingChosenShippingAndBilling spuštěno', {});
            }
        }
    }

    function resetShippingAvailabilityUi() {
        debugCartAvailability('resetShippingAvailabilityUi() - reset UI', {});

        $('#order-shipping-methods .siteMsgCustomPredob').remove();
        $('#order-shipping-methods .siteMsgCustomPredobError').remove();

        $('#order-shipping-methods .radio-wrapper').show();
        $('#order-shipping-methods .radio-wrapper input[type="radio"]').prop('disabled', false);

        $('#continue-order-button')
            .removeClass('disabled')
            .prop('disabled', false);
    }

    function hideSplitShipping() {
        const $splitWrapper = getSplitShippingWrapper();

        debugCartAvailability('hideSplitShipping() - schovávám split dopravu', {
            splitWrapperFound: $splitWrapper.length
        });

        if (!$splitWrapper.length) return;

        $splitWrapper.hide();
        $splitWrapper.find('input[type="radio"]').prop('disabled', true);
    }

    function showOnlySplitShipping() {
        const $splitWrapper = getSplitShippingWrapper();

        debugCartAvailability('showOnlySplitShipping() - start', {
            splitWrapperFound: $splitWrapper.length
        });

        if (!$splitWrapper.length) return;

        $('#order-shipping-methods .radio-wrapper').each(function () {
            const $method = $(this);

            if ($method.is($splitWrapper)) {
                $method.show();
                $method.find('input[type="radio"]').prop('disabled', false);
            } else {
                $method.hide();
                $method.find('input[type="radio"]').prop('disabled', true);
            }
        });

        selectSplitShipping();
    }

    function showPreorderClassicMessage() {
        debugCartAvailability('showPreorderClassicMessage() - zobrazuji hlášku rozdělení objednávky', {
            text: predobjednavkaText
        });

        if ($('#order-shipping-methods .siteMsgCustomPredob').length) return;

        $('#order-shipping-methods').prepend(
            '<div class="siteMsgCustomPredob">' +
                '<p>' + predobjednavkaText + '</p>' +
            '</div>'
        );
    }

    function showPreorderOwnDeliveryError() {
        debugCartAvailability('showPreorderOwnDeliveryError() - chyba předobjednávka + vlastní doprava', {
            text: preorderCustomDeliveryErrorText
        });

        if (!$('#order-shipping-methods .siteMsgCustomPredobError').length) {
            $('#order-shipping-methods').prepend(
                '<div class="siteMsgCustomPredobError">' +
                    '<p>' + preorderCustomDeliveryErrorText + '</p>' +
                '</div>'
            );
        }

        $('#order-shipping-methods .radio-wrapper').hide();
        $('#order-shipping-methods .radio-wrapper input[type="radio"]').prop('disabled', true);

        setTimeout(function () {
            $('.recapitulation-shipping-billing:not(".last")').remove();

            debugCartAvailability('showPreorderOwnDeliveryError() - odstraněna rekapitulace dopravy/platby', {});
        }, 500);

        $('#continue-order-button')
            .addClass('disabled')
            .prop('disabled', true);
    }

    function handleShippingByAvailability() {
        const items = getCartAvailabilityFromStorage();

        debugCartAvailability('handleShippingByAvailability() - start', {
            items: items
        });

        resetShippingAvailabilityUi();

        if (!items || !items.length) {
            debugCartAvailability('handleShippingByAvailability() - žádné položky, schovávám split shipping', {
                reason: 'NO_ITEMS'
            });

            hideSplitShipping();
            return;
        }

        const state = getCartAvailabilityState(items);

        /*
            Vlastní doprava + předobjednávka
            => nelze přijmout
        */
        if (state.preorderAndOwnDelivery) {
            debugCartAvailability('handleShippingByAvailability() - větev ERROR preorder + vlastní doprava', {
                reason: 'PREORDER_AND_OWN_DELIVERY',
                state: state,
                items: items
            });

            showPreorderOwnDeliveryError();
            return;
        }

        /*
            Předobjednávka + klasické zboží
            => pouze rozdělení objednávky

            Pozor:
            Ignore kódy se do hasClassic vůbec nepočítají.
            Takže dýško + předobjednávka sem nesmí spadnout.
        */
        if (state.preorderAndClassic) {
            debugCartAvailability('handleShippingByAvailability() - větev rozdělení objednávky', {
                reason: 'PREORDER_AND_CLASSIC',
                state: state,
                items: items
            });

            showPreorderClassicMessage();
            showOnlySplitShipping();
            return;
        }

        /*
            Jen předobjednávka
            Jen klasické zboží
            Jen vlastní doprava
            Vlastní doprava + klasické zboží
            Nebo předobjednávka + ignorované položky

            => klasické chování, split doprava se schová
        */
        debugCartAvailability('handleShippingByAvailability() - klasická doprava', {
            reason: 'DEFAULT_CLASSIC_BEHAVIOR',
            state: state,
            items: items
        });

        hideSplitShipping();
    }

    function initCartStepAvailabilityStorage() {
        debugCartAvailability('initCartStepAvailabilityStorage() - stránka košíku', {
            page: 'cart',
            bodyHasId9: $('.id--9').length
        });

        saveCartAvailabilityToStorage();

        $(document).on('click', '#continue-order-button', function () {
            debugCartAvailability('click #continue-order-button - ukládám dostupnosti před pokračováním', {});
            saveCartAvailabilityToStorage();
        });

        $(document).on('click', 'ol.cart-header li.step-2 a[href]', function () {
            debugCartAvailability('click step-2 - ukládám dostupnosti před přechodem na dopravu', {});
            saveCartAvailabilityToStorage();
        });
    }

    function initShippingStepAvailabilityHandling() {
        debugCartAvailability('initShippingStepAvailabilityHandling() - stránka dopravy', {
            page: 'shipping',
            bodyHasId16: $('.id--16').length
        });

        handleShippingByAvailability();

        $(document).on('change', '#order-shipping-methods input[type="radio"]', function () {
            debugCartAvailability('change shipping radio - přepočítávám dopravu', {
                value: $(this).val(),
                id: $(this).attr('id'),
                checked: $(this).prop('checked')
            });

            handleShippingByAvailability();
        });
    }

    function hideInactivePayments() {
        $('.co-payment-method .shipping-billing-table .inactive-child').hide();
    }

    if ($('.id--9').length) {
        initCartStepAvailabilityStorage();
    }

    if ($('.id--16').length) {
        initShippingStepAvailabilityHandling();
    }

    window.handleShippingByAvailability = handleShippingByAvailability;
    window.saveCartAvailabilityToStorage = saveCartAvailabilityToStorage;
    window.getCartAvailabilityFromStorage = getCartAvailabilityFromStorage;
    window.getCartAvailabilityState = getCartAvailabilityState;
    window.collectCartAvailability = collectCartAvailability;
});